module.exports = __webpack_public_path__ + "img/facebook-icon.b105bbe.png";